import React, { FC } from 'react'
import { FixedLayout } from 'components/Layout'
import { RegisterUpdateTemplate } from 'components/Templates'

const RegisterUpdate: FC = () => {
  return (
    <FixedLayout title={'アカウント紐付け完了'}>
      <RegisterUpdateTemplate />
    </FixedLayout>
  )
}

export default RegisterUpdate
